<template>
  <div>
    <PassBlockingTable />
  </div>
</template>
<script>
import PassBlockingTable from "@/v3components/Datatables/PassBlockingTable"

export default {
  name: "PassBlocking",
  components: {
    PassBlockingTable
  }
}
</script>
